export const headers = [
  { name: 'Nome', field: 'name', sortable: true },
  { name: 'Abreviação', field: 'abbreviation', sortable: true },
  { name: 'Ações', field: 'actions', sortable: false }
]
